import { Injectable } from '@angular/core';
import { GeneralService, ServiceId } from './general.service';
import { tap } from 'rxjs/operators';
import { Observable } from 'rxjs';
import { JwtHelperService } from '@auth0/angular-jwt';

@Injectable({
  providedIn: 'root'
})
export class AutenticacionService{

  autenticado: boolean = false;

  
  constructor( private _generalService: GeneralService,
    private _jwtHelper :JwtHelperService) {
    this.autenticado = localStorage.getItem("ACCESS_TOKEN")==null?false:true;
  }

  public borrarSesion(){
    this.autenticado = false;
    localStorage.removeItem('ACCESS_TOKEN');
    localStorage.removeItem('ACCESS_USUARIO');
    localStorage.removeItem('USER_LOGIN');
    localStorage.removeItem('MENU');
  }

  public autenticar(username: string, password: string):Observable<any>{
    return this._generalService.post(`${ServiceId.SSO}login`,{
      username: username,
      password: password,
      app_name: "DerechosEconomicos"
    }).pipe(tap (rta=>{
      this.autenticado = true;
      localStorage.setItem("MENU",JSON.stringify(rta.routes));
      localStorage.setItem("ACCESS_TOKEN",rta.token);
      localStorage.setItem("USER_LOGIN", username);
    }));
  }

  public hasRole(role: string):boolean{
    let usuario =  this._jwtHelper.decodeToken(localStorage.getItem("ACCESS_TOKEN"));
    return usuario.authorities.find(pRol=> pRol==role)!=null;
  }

  public hasRoleConsulta():boolean{
    return this.hasRole("DERECHOS_CONSULTA_OPERADOR") || this.hasRole("DERECHOS_CONSULTA_ANH");
  }

  public debeVerNotificacion():Observable<boolean>{
    return this._generalService.get(`${ServiceId.DERECHOS}usuario/verNotaInicial`);
  }

  public verificarToken() {
    return this._generalService.get(`${ServiceId.SSO}Login/verificartoken`);
  }
}
